import { fileToBase64 } from './fileToBase64';
import { IFile } from './IFile';

export const readFile = async (file: File): Promise<IFile> => {
	return {
		contentAsBase64: await fileToBase64(file),
		fileName: file.name,
	};
};
